var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "ma-0 pa-0", attrs: { width: "100%", outlined: "" } },
    [
      _c(
        "v-toolbar",
        { attrs: { flat: "" } },
        [
          _c("v-toolbar-title", [_vm._v("Branches")]),
          _c("v-divider", {
            staticClass: "mx-2",
            attrs: { inset: "", vertical: "" },
          }),
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { color: "accent" }, on: { click: _vm.row_create } },
                [_vm._v(" Add Branch ")]
              ),
            ],
            1
          ),
          _c("v-spacer"),
        ],
        1
      ),
      _c("v-data-table", {
        staticStyle: { width: "100%" },
        attrs: {
          "fixed-header": "",
          items: _vm.branches,
          headers: _vm.headers,
          "hide-default-footer": "",
          "sort-by": _vm.sortBy,
          "sort-desc": _vm.sortDesc,
          "disable-pagination": "",
        },
        on: {
          "update:sortBy": function ($event) {
            _vm.sortBy = $event
          },
          "update:sort-by": function ($event) {
            _vm.sortBy = $event
          },
          "update:sortDesc": function ($event) {
            _vm.sortDesc = $event
          },
          "update:sort-desc": function ($event) {
            _vm.sortDesc = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "item.groups",
            fn: function ({ item }) {
              return [
                _c(
                  "div",
                  _vm._l(item.groups, function (group) {
                    return _c(
                      "v-chip",
                      {
                        key: group.name,
                        staticClass: "ma-1",
                        attrs: {
                          color: "blue lighten-4",
                          "text-color": "blue--text",
                          small: "",
                        },
                      },
                      [_vm._v(" " + _vm._s(group.name) + " ")]
                    )
                  }),
                  1
                ),
              ]
            },
          },
          {
            key: "item.actions",
            fn: function ({ item }) {
              return [
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.row_update(item)
                      },
                    },
                  },
                  [_vm._v("mdi-pencil")]
                ),
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.row_copy(item)
                      },
                    },
                  },
                  [_vm._v("mdi-content-copy")]
                ),
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.row_remove(item)
                      },
                    },
                  },
                  [_vm._v("mdi-delete")]
                ),
              ]
            },
          },
        ]),
      }),
      _c("c-branch-dialog", { ref: "branchDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }